import { CSSObject, Theme } from '@core-ui/react-stitch';
import getFocusStyle from '../getFocusStyle';
import getTextStyles from '../getTextStyles';
import getControlBeforeStyles from '../getControlBeforeStyles';

const getControlStyles = (isBRFontEnabled: boolean, isBRRedesignEnabled: boolean, isBRRedesignOpacityEnabled: boolean) => (
  base: CSSObject,
  { theme }: { theme: Theme }
): CSSObject => ({
  ...base,
  ...getTextStyles(theme, isBRFontEnabled, isBRRedesignEnabled),
  borderRadius: '0.25rem',
  paddingLeft: '0.5rem',
  paddingRight: '1.25rem',
  '&:focus': getFocusStyle(theme),
  '&:focus-visible': getFocusStyle(theme),
  '&:focus:not(:focus-visible)': {
    animation: 'none',
    border: 'none',
    outline: 'none'
  },
  ...isBRRedesignEnabled
    ? {
      '&::before': getControlBeforeStyles(theme),
      '&:hover': {
        backgroundColor: theme.color.b2,
        animation: 'none !important',
        border: 'none',
        outline: 'none'
      },
      backgroundColor: `${theme.color.b2}${isBRRedesignOpacityEnabled ? '9E' : '00'}`,
      borderRadius: 'none',
      height: '2.5rem',
      paddingLeft: '1rem',
      paddingRight: '1.688rem',
      border: 'none',
    }
    : {}
});

export default getControlStyles;
